import { nextTick } from 'vue';
import { useApi } from './useApi';
import { useAppState } from './useAppState';
import { useCustomer } from './useCustomer';
import { getHttpInstance, getApiConfig } from './useApi';
export function useWhatsApp(refs) {
    const api = useApi();
    const state = useAppState();
    const customer = useCustomer();
    function enableWhatsApp() {
        const request = {
            title: "welcome_to_mg",
            whatsApp: true,
            whatsAppTemplate: true,
            phoneNumber: state.customer.person.mobilePhone
        };
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications", request)
            .then(() => { })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => enableWhatsApp());
            }
        });
    }
    function sendWhatsAppNotification(body, phoneNumber, onSuccess = null) {
        const request = {
            body: body,
            whatsApp: true,
            whatsAppTemplate: false,
            phoneNumber: phoneNumber
        };
        getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications", request)
            .then(() => {
            if (onSuccess)
                onSuccess();
        })
            .catch((result) => {
            if (result.response && result.response.status == 401) {
                api.refreshLogin(() => sendWhatsAppNotification(body, phoneNumber, onSuccess));
            }
        });
    }
    function openWhatsAppChat() {
        window.location.href = `https://wa.me/${refs.whatsAppNumber}`;
    }
    function handleWhatsAppAction() {
        customer.getCustomer(() => {
            if (state.customer.person.whatsAppEnabled) {
                sendWhatsAppNotification("You indicated you wanted to send a document 📄  Just drop it here and we will upload and process it for you 👍", state.customer.person.mobilePhone);
                nextTick(() => {
                    if (refs.whatsAppPromoCard?.value) {
                        refs.whatsAppPromoCard.value?.setClicked();
                    }
                });
                openWhatsAppChat();
            }
            else {
                if (refs.whatsAppEnableDrawer?.value) {
                    refs.whatsAppEnableDrawer.value?.openDrawer();
                }
            }
        }, false);
    }
    function handleEnableWhatsApp() {
        enableWhatsApp();
    }
    function handleWhatsAppEnableDone() {
        customer.getCustomer(null, false);
        if (refs.whatsAppPromoCard?.value) {
            refs.whatsAppPromoCard.value?.reset();
        }
    }
    function handleWhatsAppDrawerClosed() {
        if (refs.whatsAppPromoCard?.value) {
            refs.whatsAppPromoCard.value?.reset();
        }
    }
    return {
        enableWhatsApp,
        sendWhatsAppNotification,
        openWhatsAppChat,
        handleWhatsAppAction,
        handleEnableWhatsApp,
        handleWhatsAppEnableDone,
        handleWhatsAppDrawerClosed,
    };
}
